import { create } from "zustand";
import type  { UserAuthApiResponse } from "../types/user";
import { getAuthStatus } from "../services/authService";

interface UserState {
  user: UserAuthApiResponse["data"] | null;
  setUser: (user: UserAuthApiResponse["data"]) => void;
  refetchAuthStatus: () => Promise<UserAuthApiResponse>;
  clearUser: () => void;
}

const useUserStore = create<UserState>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
  refetchAuthStatus: async () => {
    const data = await getAuthStatus();
    set({ user: data.data });
    return data;
  },
}));

export default useUserStore;
